import * as React from 'react'
import { useEffect, useReducer, useState } from 'react'
import { Container } from 'typescript-ioc/es5'
import { AppService } from '@halo/services/app.service'
import { Form, Input, Select } from 'antd'
import { PageAnalysisFieldStrategyType } from '@pushly/aqe/lib/enums/page-analysis-field-strategy-type'
import { Drawer } from '@pushly/aqe/lib/components'
import { useForm } from 'antd/es/form/Form'
import { IPageAnalysisFieldStrategy } from '@pushly/aqe/lib/interfaces'

export interface IEditFieldConfigStrategyParams {
    fieldConfigStrategy: Partial<IPageAnalysisFieldStrategy>
    ordinal?: number
}

export interface IEditFieldConfigStrategyDrawerProps {
    params: IEditFieldConfigStrategyParams
    onClose: () => void
    onUpdate: (fieldConfigStrategy: IPageAnalysisFieldStrategy, ordinal?: number) => void
}

function EditFieldConfigStrategyDrawer(props: IEditFieldConfigStrategyDrawerProps) {
    const appService = Container.get(AppService)
    const [fieldConfigStrategy] = useState(props.params?.fieldConfigStrategy)
    const [form] = useForm<IPageAnalysisFieldStrategy>()
    const [_, refresh] = useReducer((x) => x + 1, 0)

    useEffect(() => {
        form.setFieldsValue({
            type: null,
            config: null,
            ...props.params?.fieldConfigStrategy,
        })
        refresh()
    }, [props.params?.fieldConfigStrategy])

    function render() {
        return (
            <Drawer
                width={600}
                getContainer={appService.getAppContainer}
                className="edit-field-config-drawer"
                title={props.params?.ordinal != null ? 'Edit Field Config Strategy' : 'Add Field Config Strategy'}
                placement="right"
                closable={true}
                submitText={
                    props.params?.ordinal != null ? 'Update Field Config Strategy' : 'Add Field Config Strategy'
                }
                onSubmit={() => {
                    form.submit()
                }}
                onClose={props.onClose}
                visible={!!props.params?.fieldConfigStrategy}
            >
                {props.params?.fieldConfigStrategy && (
                    <Form
                        layout="horizontal"
                        form={form}
                        onFinish={() => {
                            props.onUpdate(form.getFieldsValue() as IPageAnalysisFieldStrategy, props.params.ordinal)
                        }}
                    >
                        <Form.Item label="Type" name="type" rules={[{ required: true, message: 'Type is required' }]}>
                            <Select
                                onChange={(e: any) => {
                                    refresh()
                                }}
                            >
                                <Select.Option
                                    key={PageAnalysisFieldStrategyType.XPATH}
                                    value={PageAnalysisFieldStrategyType.XPATH}
                                >
                                    xpath
                                </Select.Option>
                                <Select.Option
                                    key={PageAnalysisFieldStrategyType.JSONLD}
                                    value={PageAnalysisFieldStrategyType.JSONLD}
                                >
                                    jsonld
                                </Select.Option>
                                <Select.Option
                                    key={PageAnalysisFieldStrategyType.JSONPATH}
                                    value={PageAnalysisFieldStrategyType.JSONPATH}
                                >
                                    jsonpath
                                </Select.Option>
                            </Select>
                        </Form.Item>

                        {form.getFieldValue('type') === PageAnalysisFieldStrategyType.XPATH && (
                            <Form.Item
                                label="XPath"
                                name={['config', 'xpath']}
                                rules={[{ required: true, message: 'XPath is required' }]}
                            >
                                <Input autoComplete="off" />
                            </Form.Item>
                        )}

                        {form.getFieldValue('type') === PageAnalysisFieldStrategyType.JSONLD && (
                            <>
                                <Form.Item
                                    label="Schema Type"
                                    name={['config', 'schema_type']}
                                    rules={[{ required: true, message: 'Schema Type is required' }]}
                                >
                                    <Input autoComplete="off" />
                                </Form.Item>

                                <Form.Item
                                    label="Json Path"
                                    name={['config', 'json_path']}
                                    rules={[{ required: true, message: 'Json Path is required' }]}
                                >
                                    <Input autoComplete="off" />
                                </Form.Item>
                            </>
                        )}

                        {form.getFieldValue('type') === PageAnalysisFieldStrategyType.JSONPATH && (
                            <>
                                <Form.Item
                                    label="HTML Element ID"
                                    name={['config', 'element_id']}
                                    rules={[{ required: true, message: 'HTML Element ID is required' }]}
                                >
                                    <Input autoComplete="off" />
                                </Form.Item>

                                <Form.Item
                                    label="Json Path"
                                    name={['config', 'json_path']}
                                    rules={[{ required: true, message: 'Json Path is required' }]}
                                >
                                    <Input autoComplete="off" />
                                </Form.Item>
                            </>
                        )}
                    </Form>
                )}
            </Drawer>
        )
    }

    return render()
}

export default EditFieldConfigStrategyDrawer
